// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TransactionContext = {
    Auction: 'AUCTION',
    InstantSale: 'INSTANT_SALE',
    Offer: 'OFFER',
    GlobalOffer: 'GLOBAL_OFFER',
    Mint: 'MINT',
    Unknown: 'UNKNOWN'
} as const;
export type TransactionContext = typeof TransactionContext[keyof typeof TransactionContext];


export function TransactionContextFromJSON(json: any): TransactionContext {
    return TransactionContextFromJSONTyped(json, false);
}

export function TransactionContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionContext {
    return json as TransactionContext;
}

export function TransactionContextToJSON(value?: TransactionContext | null): any {
    return value as any;
}

